import { useEffect, useRef } from 'react'
import { AppState, Platform } from 'react-native'

const isActive = (state) => state === 'active'

export const useAppStateChange = ({ onForeground, onBackground }, dependencies) => {
  const appState = useRef(AppState.currentState)

  useEffect(() => {
    const handleAppStateChange = (nextAppState) => {
      if (!isActive(appState.current) && isActive(nextAppState)) {
        onForeground && onForeground()
      } else {
        onBackground && onBackground()
      }

      appState.current = nextAppState
    }

    const subscription = AppState.addEventListener('change', handleAppStateChange)

    // todo Maintained for RNW@0.15, switch to sub.remove() once upgraded
    return () =>
      Platform.OS === 'web'
        ? AppState.removeEventListener('change', handleAppStateChange)
        : subscription.remove()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies)
}
